import comp from "./TextWithEllipsis";
export default comp;
